import { action, computed, makeObservable, observable, reaction, runInAction } from 'mobx';
import Filter from './filter';
import { getCustomerPrice } from 'api/user';

class OrderFormState {

    selectedEvent = null;
    specialist = null;
    amount = 1;
    selectedEvents = new Array(1).map(x => null);
    choosePriority = 'specialist';
    price = 0;
    submitting = false;
    submitSuccess = false;
    ticketType = null;
    username = null;
    order = null;

    constructor(model) {
        this.filter = new Filter(model);
        makeObservable(this, {
            model: false,
            selectedEvent: observable,
            setSelectedEvent: action.bound,
            setSpecialist: action.bound,
            specialist: observable,
            amount: observable,
            setAmount: action.bound,
            selectedEvents: observable,
            setSelectedEvents: action.bound,
            resetSelectedEvents: action.bound,
            filtered: computed,
            choosePriority: observable,
            setChoosePriority: action.bound,
            workingOffline: computed,
            workingWithPairs: computed,
            price: observable,
            setPrice: action.bound,
            submitting: observable,
            submitSuccess: observable,
            setSubmitSuccess: action.bound,
            username: observable,
            setUsername: action.bound,
            events: computed,
            setSubmitting: action.bound,
            order: observable,
            setOrder: action.bound,
            ticketType: observable,
            setTicketType: action.bound
        })
        this.model = model;
    }

    init = () => {

        this.disposer = [];

        this.disposer.push(
            reaction(() => this.choosePriority,
                () => {
                    //this.model.filter.resetFilters();
                    this.setSelectedEvent(null);
                }),
            reaction(() => ({
                    events: this.events,
                    choosePriority: this.choosePriority
                }),
                () => {
                    if (this.choosePriority === 'date') {
                        this.setSelectedEvent(this.closestEvent);
                        this.setSpecialist(null);
                    }
                }),
            reaction(() => this.selectedEvent,
                () => {
                    if (this.choosePriority === 'date') {
                        this.setSelectedEvents(0, this.selectedEvent);
                    }
                }),
            reaction(() => this.specialist,
                () => {
                    if (this.specialist === null && this.choosePriority === 'specialist') {
                        this.setAmount(1);
                        this.resetSelectedEvents(1, true);
                    }
                }),
            reaction(() => this.amount,
                (amount) => {
                    this.resetSelectedEvents(amount);
                }),
            reaction(() => ({ amount: this.amount, specialist: this.specialist }),
                () => {
                    let price;
                    if (this.specialist) {
                        if (this.amount > 1) {
                            price = this.specialist.ticketOptions.find(to => to.visit === this.amount).price;
                        } else {
                            price = this.specialist.data.servicesSet[0].price
                        }
                    } else {
                        price = null;
                    }
                    this.setPrice(price);
                }),
            reaction(() => ({ amount: this.amount, specialist: this.specialist, workingOffline: this.workingOffline, username: this.username }),
                () => {
                    if (this.specialist) {
                        const meetingType = this.workingOffline ? 'OFF' : 'ON';
                        const service = this.specialist.data.servicesSet.find(ss => ss.meetingType === meetingType);
                        const visits = this.amount;
                        if (this.model.user.isAuthenticated) {
                            //todo: cache!!! every time on visits change it sends request
                            if (service?.id && visits) {
                                getCustomerPrice({ service: service.id, visits, phone: this.model.user.username }).then((customerPrice) => {
                                    this.setPrice(customerPrice);
                                })
                            }
                        } else {
                            const username = this.username;
                            if (service?.id && visits && username) {
                                getCustomerPrice({ service: service.id, visits, phone: username }).then((customerPrice) => {
                                    this.setPrice(customerPrice);
                                })
                            }
                        }
                    } else {
                        this.setPrice(null);
                    }
                })
        )

        runInAction(() => {
            if (this.events.length > 0 && this.selectedEvent === null) {
                this.selectedEvent = this.closestEvent;
            }
        })

    }

    setOrder(order) {
        this.order = order;
    }

    setUsername(value) {
        this.username = value;
    }

    setSubmitting(value) {
        this.submitting = value;
    }

    setSubmitSuccess(value) {
        this.submitSuccess = value;
    }

    setTicketType(value) {
        this.ticketType = value;
    }

    reset = () => {
        runInAction(() => {
            this.selectedEvent = null;
            this.specialist = null;
            this.amount = 1;
            this.selectedEvents = new Array(1).map(x => null);
            this.choosePriority = 'specialist';
            this.price = 0;
            this.submitting = false;
            this.submitSuccess = false;
            this.username = false;
            this.order = null;
        })
        this.filter.resetFilters();
        this.disposer.forEach(dispose => dispose());
    }

    setPrice(price) {
        this.price = price;
    }

    get workingOffline() {
        return this.filter.filters.workingOffline;
    }

    get workingWithPairs() {
        return this.filter.filters.workingWithPairs;
    }

    setChoosePriority(value) {
        this.choosePriority = value;
    };

    resetSelectedEvents(amount, reset = false) {
        if (reset) {
            this.selectedEvents = new Array(amount).map(x => null);
            return;
        }
        let newSelectedEvents = this.selectedEvents.slice(0, amount);
        if (amount >= this.selectedEvents.length) {
            newSelectedEvents = [
                ...newSelectedEvents,
                ...[ ...new Array(amount - this.selectedEvents.length) ].map(x => null)
            ]
        }
        this.selectedEvents = newSelectedEvents;
    }

    setSelectedEvents(index, value) {
        const oldEvents = this.selectedEvents;
        const newEvents = [
            ...oldEvents.slice(0, index),
            value,
            ...oldEvents.slice(index + 1)
        ];
        this.selectedEvents = newEvents;
    }

    setAmount(data) {
        this.amount = data;
    }

    setSpecialist(name) {
        if (name) {
            this.specialist = this.model.specialist.specialists.find(spec => spec.name === name);
        } else {
            this.specialist = null;
        }
    }

    setSelectedEvent(date) {
        this.selectedEvent = date;
    }

    get ticketOptions() {
        const availableSlots = this.specialistEvents.length;
        return this.specialist.ticketOptions.filter(({ visit }) => visit <= availableSlots);
    }

    get filtered() {
        const { workingOffline, cities: city, districts: district } = this.filter.filters;
        const meetingType = workingOffline ? 'OFF' : 'ON';
        if (this.selectedEvent && this.choosePriority === 'date') {
            return this.filter.filtered.filter((specialist) => {
                return specialist
                    .filterEvents({ meetingType, city, district })
                    .some(e => {
                        return e.startDate === this.selectedEvent
                    });
            });
        }
        return this.filter.filtered;
    }

    get events() {
        const { filters: { districts: district, cities: city, workingOffline }, filtered: specialists } = this.filter;
        const meetingType = workingOffline ? 'OFF' : 'ON';
        const filteredEvents = [];
        for (const specialist of specialists) {
            const specEvents = specialist.filterEvents({ meetingType, city, district });
            filteredEvents.push(...specEvents.map(e => e.startDate));
        }
        return [ ...new Set(filteredEvents) ];
    }

    get specialistEvents() {
        if (!this.specialist) { return this.events; }
        const { filters: { districts: district, cities: city, workingOffline } } = this.filter;
        const meetingType = workingOffline ? 'OFF' : 'ON';
        return this.specialist.filterEvents({ meetingType, city, district }).map(e => e.startDate);
    }

    get closestEvent() {
        if (this.events.length <= 0) {
            return null;
        }
        return this.model.events._findClosestEvent(this.events);
    }
}

export default OrderFormState;
